import "../../chunk-BUSYA2B4.js";
import { useRouter } from "next/compat/router";
const usePagesRouter = () => {
  return { pagesRouter: useRouter() };
};
export {
  usePagesRouter
};
//# sourceMappingURL=usePagesRouter.js.map